import script from "./clInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./clInfo.vue?vue&type=script&setup=true&lang=js"

import "./clInfo.vue?vue&type=style&index=0&id=416fbe7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416fbe7a"]])

export default __exports__